import type { ReactNode } from "react";
import styles from "./Overlay.module.css";
import { OverlayShell } from "./OverlayShell";

interface DrawerProps {
  open: boolean;
  onDismiss: () => void;
  title: string;
  children: ReactNode;
  /** Optional footer element (typically action buttons). */
  footer?: ReactNode;
}

/**
 * Drawer — 440px right, `--scrim` backdrop, focus trapped, close on
 * Escape / scrim click / Close button. Never commits on dismiss.
 *
 * Used for the transaction detail view on Activity.
 */
export function Drawer({ open, onDismiss, title, children, footer }: DrawerProps) {
  return (
    <OverlayShell
      open={open}
      onDismiss={onDismiss}
      ariaLabel={title}
      variant="drawer"
    >
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <button
          type="button"
          className={styles.close}
          onClick={onDismiss}
          aria-label="Close"
        >
          Close
        </button>
      </div>
      <div style={{ flex: 1 }}>{children}</div>
      {footer ? <div>{footer}</div> : null}
    </OverlayShell>
  );
}
